import { connect } from 'react-redux'
import { listTableStyle } from '../../styles'
import { preRegistrationsActions, confirmActions, messageActions } from '../../actions'
import { reloadTable } from '../../utils/reloadTable'
import { withStyles } from '@material-ui/core/styles'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import CircularProgress from '@material-ui/core/CircularProgress'
import IconButton from '@material-ui/core/IconButton'
import ImageEdit from 'material-ui/svg-icons/image/edit'
import Paper from '@material-ui/core/Paper'
import React, { Component, Fragment } from 'react'
import TablePagination from '@material-ui/core/TablePagination'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import Typography from '@material-ui/core/Typography'
import Undo from 'material-ui/svg-icons/content/undo'
import { findPermission, readOnly } from '../../utils/permissions'
import Visibility from '@material-ui/icons/Visibility'

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'

class ListTable extends Component {
  state = {
    debounce: undefined
  }

  componentWillUpdate(newProps) {
    const { pagination, order, fetchPreRegistrations, term } = newProps
    const { page, rowsPerPage: perPage } = pagination

    if (reloadTable(newProps, this.props)) {
      const debounce = setTimeout(() => {
        fetchPreRegistrations({ page, perPage, order, term })
      }, 700)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }

    return true
  }

  componentDidMount() {
    const { fetchPreRegistrations } = this.props

    fetchPreRegistrations()
  }

  renderActions = item => {
    const {
      fetchPreRegistration,
      token,
      addConfirm,
      restorePreRegistration,
      deletePreRegistration
    } = this.props

    return (
      <Fragment>
        {readOnly(item.tipo, token) &&
          !item.deletedAt && (
            <IconButton
              onClick={() => {
                fetchPreRegistration(item._id)
              }}
            >
              <Visibility nativeColor={'rgba(0, 0, 0, 0.87)'} />
            </IconButton>
          )}

        {!!item.deletedAt && findPermission(item.tipo, token).remover ? (
          <IconButton
            onClick={() => {
              const { changeMessage } = this.props

              addConfirm({
                confirmMessage: 'Confirma a restauração deste pré-cadastro?',
                confirmFunction: () => {
                  restorePreRegistration(item._id)
                  changeMessage({ message: 'Restauração realizada com sucesso.' })
                }
              })
            }}
          >
            <Undo />
          </IconButton>
        ) : (
          <Fragment>
            {findPermission(item.tipo, token).editar && (
              <IconButton
                onClick={() => {
                  fetchPreRegistration(item._id)
                }}
              >
                <ImageEdit />
              </IconButton>
            )}

            {findPermission(item.tipo, token).remover && (
              <IconButton
                onClick={() => {
                  const { changeMessage } = this.props

                  addConfirm({
                    confirmMessage: 'Confirma a exclusão desta pré-cadastro?',
                    confirmFunction: () => {
                      deletePreRegistration(item._id)
                      changeMessage({ message: 'Exclusão realizada com sucesso.' })
                    }
                  })
                }}
              >
                <ActionDelete />
              </IconButton>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  }

  handleChangePage = (event, page) => {
    const { handleChangePage } = this.props

    handleChangePage(page)
  }

  handleChangeRowsPerPage = event => {
    const perPage = event.target.value
    const { handleChangePerPage } = this.props

    handleChangePerPage(perPage)
  }

  handleSortTable = column => {
    const { order, changeOrderColumn, changeOrderDirection } = this.props

    if (column === ((order || {}).column || '')) {
      const direction = ((order || {}).direction || 1) === -1 ? 1 : -1

      changeOrderDirection(direction)
    } else {
      changeOrderColumn(column)
    }
  }

  render() {
    const {
      classes,
      preRegistrations = [],
      loadingPreRegistrations,
      pagination,
      order = {}
    } = this.props

    return (
      <Paper className={classes.wrapperTable} elevation={4}>
        {!!loadingPreRegistrations && (
          <div className={classes.wrapperLoader}>
            <CircularProgress />
          </div>
        )}

        <Table
          fixedHeader={true}
          width={'990px'}
          wrapperStyle={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'var(--crud-table-height)'
          }}
        >
          <TableHeader
            displaySelectAll={false}
            className={classes.tableHeader}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'titulo'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('titulo')
                  }}
                >
                  Título
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'tipo'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('tipo')
                  }}
                >
                  Tipo
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '100px' }}>Ações</TableHeaderColumn>
            </TableRow>
          </TableHeader>

          <TableBody displayRowCheckbox={false} className={classes.tableBody}>
            {(preRegistrations || []).length ? (
              (preRegistrations || []).map(preRegistration => {
                return (
                  <TableRow key={preRegistration._id}>
                    <TableRowColumn>{preRegistration.titulo || '--'}</TableRowColumn>
                    <TableRowColumn className={classes.capitalizeField}>
                      {preRegistration.tipo || '--'}
                    </TableRowColumn>
                    <TableRowColumn style={{ width: '100px' }}>
                      {this.renderActions(preRegistration)}
                    </TableRowColumn>
                  </TableRow>
                )
              })
            ) : (
              <TableRow>
                <TableRowColumn>
                  <Typography noWrap style={{ textAlign: 'center', padding: '16px' }}>
                    {!!loadingPreRegistrations ? 'Carregando...' : 'Não há registros.'}
                  </Typography>
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <div className={classes.paginationWrapper}>
          <div className={classes.page}>Página: {pagination.page + 1}</div>

          <TablePagination
            component="div"
            className={classes.pagination}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count, page }) => {
              return `Exibindo de ${from} a ${to} de ${count}`
            }}
            count={pagination.length}
            rowsPerPage={pagination.rowsPerPage}
            rowsPerPageOptions={[25, 50, 100]}
            page={pagination.page}
            backIconButtonProps={{
              'aria-label': 'Página anterior'
            }}
            nextIconButtonProps={{
              'aria-label': 'Próxima página'
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    )
  }
}

const mapStateToProps = state => {
  return {
    loadingPreRegistrations: state.preRegistrations.loadingPreRegistrations,
    order: state.preRegistrations.order,
    pagination: state.preRegistrations.preRegistrationsPagination,
    preRegistration: state.preRegistrations.preRegistration,
    preRegistrations: state.preRegistrations.preRegistrations,
    term: state.searchTable.term,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(preRegistrationsActions.openModal())
    },
    closeModal: () => {
      dispatch(preRegistrationsActions.closeModal())
    },
    fetchPreRegistration: id => {
      dispatch(preRegistrationsActions.fetchPreRegistration(id))
    },
    fetchPreRegistrations: options => {
      dispatch(preRegistrationsActions.fetchPreRegistrations(options))
    },
    deletePreRegistration: id => {
      dispatch(preRegistrationsActions.deletePreRegistration(id))
    },
    handleChangePage: page => {
      dispatch(preRegistrationsActions.handleChangePage(page))
    },
    handleChangePerPage: perPage => {
      dispatch(preRegistrationsActions.handleChangePerPage(perPage))
    },
    addConfirm: ({ confirmMessage, confirmFunction }) => {
      dispatch(confirmActions.addFunction({ confirmMessage, confirmFunction }))
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    restorePreRegistration: id => {
      dispatch(preRegistrationsActions.restorePreRegistration(id))
    },
    changeOrderColumn: column => {
      dispatch(preRegistrationsActions.changeOrderColumn(column))
    },
    changeOrderDirection: direction => {
      dispatch(preRegistrationsActions.changeOrderDirection(direction))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(listTableStyle)(ListTable))



// WEBPACK FOOTER //
// ./src/containers/PreRegistration/ListTable.js